import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'commentActionLabel',
    standalone: false
})
export class CommentActionLabelPipe implements PipeTransform {
    static format(...comment: string[]): string {
        const hasComment = comment.some(c => !!c);
        const [editPronoun, addPronoun, plural] = arguments.length > 1 ? ['les', 'des', 's'] : ['le', 'un', ''];

        return (hasComment ? `Modifier ${editPronoun}` : `Ajouter ${addPronoun}`) + ` commentaire${plural}`;
    }

    transform(...comment: string[]): string {
        return CommentActionLabelPipe.format(...comment);
    }
}
